import { m } from "framer-motion";
// @mui
import { Box, SxProps } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
//

import ProgressBar from "../pages/ProgressBar";
import Logo from "~components/Logo";

// ----------------------------------------------------------------------

const RootStyle = styled("div")<{ fullScreen: boolean | undefined }>(
  ({ theme, fullScreen }) => ({
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(fullScreen === false
      ? {
          //position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "auto",
          height: "auto",
          backgroundColor: "transparent",
        }
      : {
          width: "100%",
          height: "100%",
          position: "fixed",
          right: 0,
          bottom: 0,
          backgroundColor: theme.palette.background.default,
        }),
  }),
);

// ----------------------------------------------------------------------

type Props = {
  isDashboard?: boolean;
  fullScreen?: boolean;
  sx?: SxProps;
  /**
   * If true, hides the progress bar (to prevent flashing during tab navigation)
   */
  hideProgress?: boolean;
};

export default function LoadingScreen({
  isDashboard,
  fullScreen,
  hideProgress = false,
  ...other
}: Props) {
  return (
    <>
      {/* Only show progress bar if not explicitly hidden */}
      {!hideProgress && <ProgressBar />}

      {!isDashboard && (
        <RootStyle fullScreen={fullScreen} {...other}>
          <m.div
            animate={{
              scale: [1, 0.9, 0.9, 1, 1],
              opacity: [1, 0.48, 0.48, 1, 1],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeatDelay: 1,
              repeat: Infinity,
            }}
          >
            <Logo />
          </m.div>

          <Box
            component={m.div}
            animate={{
              scale: [1.2, 1, 1, 1.2, 1.2],
              rotate: [270, 0, 0, 270, 270],
              opacity: [0.25, 1, 1, 1, 0.25],
              borderRadius: ["25%", "25%", "50%", "50%", "25%"],
            }}
            transition={{ ease: "linear", duration: 3.2, repeat: Infinity }}
            sx={{
              width: 100,
              height: 100,
              borderRadius: "25%",
              position: "absolute",
              border: (theme) =>
                `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
            }}
          />

          <Box
            component={m.div}
            animate={{
              scale: [1, 1.2, 1.2, 1, 1],
              rotate: [0, 270, 270, 0, 0],
              opacity: [1, 0.25, 0.25, 0.25, 1],
              borderRadius: ["25%", "25%", "50%", "50%", "25%"],
            }}
            transition={{
              ease: "linear",
              duration: 3.2,
              repeat: Infinity,
            }}
            sx={{
              width: 120,
              height: 120,
              borderRadius: "25%",
              position: "absolute",
              border: (theme) =>
                `solid 8px ${alpha(theme.palette.primary.dark, 0.24)}`,
            }}
          />
        </RootStyle>
      )}
    </>
  );
}
